var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message"},[_c('section',{staticClass:"message__wrapper"},[(_vm.modalText)?_c('div',{staticClass:"message__text",domProps:{"innerHTML":_vm._s(_vm.modalText)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }